// 📁 src/axiosClient.js
import axios from "axios";
import { API_BASE } from "./apiBase";

if (process.env.NODE_ENV !== "production") {
  // Helpful during debugging
  // eslint-disable-next-line no-console
  console.log("✅ API_BASE resolved to:", API_BASE);
}

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
  withCredentials: true, // ✅ keep consistent with fetch(..., credentials:"include")
});

// Optional: cleaner error messages (keeps UI toast messages nicer)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Network / CORS / timeout errors often have no err.response
    if (!err.response) {
      err.message =
        err.code === "ECONNABORTED"
          ? "Request timed out. Please try again."
          : "Network error. Please check your connection.";
    }
    return Promise.reject(err);
  }
);
